<div class="show-box-container">
  <div [ngClass]="hideBox" class="change-photo-message-box">
    <span class="change-photo-message">{{ changePhotoMessage }}</span>
    <img
      class="close-message-box"
      src="/assets/icons/Icon-closed.png"
      (click)="closeMessage()"
    />
  </div>
  <div [ngClass]="hideBox" class="change-photo-message-triangle-below"></div>
  <img [ngClass]="closePicture" src="{{ imgPhoto }}" (click)="changeImage()" />
</div>
